import { 
  ContactType, ContactInfoInput
} from 'src/services/graphql/Models';
import { Parsable } from 'src/shared/utility';

export default class ContactInfo implements ContactInfoInput, Parsable {
  contactType: ContactType;
  contact: string;
  
  constructor ( from: any ) { 
    this.contactType = from.contactType;
    this.contact = from.contact + '';
  }
  
  parseAbsolute() {
    return {
      contactType: this.contactType,
      contact: this.contact
    };
  }
}


// WEBPACK FOOTER //
// ./src/stores/application/classes/ContactInfo.ts